import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Segment, Divider, Checkbox } from 'semantic-ui-react';

import { fetchTeam, updateTeam } from '../actions/teams';
import { deleteSlackChatIntegration } from '../actions/integrations';

import TeamForm from '../components/TeamForm';

const SLACK_CHAT_INTEGRATION = 'slack_chat';

class TeamEdit extends React.Component {
  constructor(props) {
    super(props);

    this.handleConnectWithSlackChange = this.handleConnectWithSlackChange.bind(
      this
    );
  }

  componentWillMount() {
    this.props.fetchTeam(this.teamId);
  }

  get teamId() {
    return this.props.match.params.teamId;
  }

  get slackIntegration() {
    return (
      this.props.team &&
      this.props.team.integrations.find(
        integration => integration.name === SLACK_CHAT_INTEGRATION
      )
    );
  }

  canEdit(team) {
    return team.policy.update;
  }

  handleConnectWithSlackChange(event, data) {
    if (data.checked) {
      window.location.href = `${
        process.env.REACT_APP_AUTH_SLACK_CHAT_URL
      }?team=${this.teamId}`;
    } else {
      this.props.deleteSlackChatIntegration(this.teamId);
    }
  }

  render() {
    const { team } = this.props;

    // redirect if user does not have management permissions
    if (team && !this.canEdit(team)) {
      return (
        <Redirect
          to={{
            pathname: `/team/${team.slug}`
          }}
        />
      );
    }

    const { handleSubmit } = this.props;

    return (
      <Segment basic className="TeamEdit">
        <Container text textAlign="right">
          <Checkbox
            toggle
            label="Connect with Slack"
            checked={this.slackIntegration && this.slackIntegration.enabled}
            onChange={this.handleConnectWithSlackChange}
          />
        </Container>
        <Divider />
        <TeamForm team={team} onSubmit={handleSubmit} />
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  team: state.teams.team
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchTeam: teamId => {
    dispatch(fetchTeam(teamId));
  },
  handleSubmit: attributes => {
    dispatch(updateTeam(ownProps.match.params.teamId, attributes));
  },
  deleteSlackChatIntegration: teamId => {
    dispatch(deleteSlackChatIntegration(teamId)).then(() =>
      dispatch(fetchTeam(teamId))
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamEdit);



// WEBPACK FOOTER //
// ./src/containers/TeamEdit.js